import IParser from "@/types/IParser"
import { IUserRenewal } from "./userRenewal.types"
import { UserRenewal } from "./userRenewal"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { safeDayjs } from "@/helpers/dateHelper"

type IUserRenewalRaw = {
  id: number
  created_at: string
  uploaded_at?: string | null
  renewal_agreements?: {
    contents?: {
      productvariants: {
        id: number
        meterpoints: {
          id: number
        }[]
      }[]
    }
  }[]
}

export const UserRenewalParser: IParser<IUserRenewal, IUserRenewalRaw> = {
  toDomain: (data) => {
    try {
      const meterpointIds: number[] =
        data.renewal_agreements?.flatMap(
          (agreement) =>
            agreement.contents?.productvariants.flatMap((productVariant) =>
              productVariant.meterpoints.map((meterpoint) => meterpoint.id),
            ) ?? [],
        ) ?? []

      return new UserRenewal(
        data.id,
        dayjs(data.created_at),
        meterpointIds,
        safeDayjs(data.uploaded_at),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
